import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const MyDevicesPage = lazy(() => import("./MyDevicesPage"));

const MyDevicesPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MyDevicesPage />
    </Suspense>
  );
};

export default MyDevicesPageLazy;
